import SearchBar from 'components/Autosuggest/Autosuggest';
import React, { useEffect, useState } from 'react';
import { searchItems } from 'services';
import { createUserInventoryItemPreference, updateUserInventoryItemPreference } from 'services/api/users';
import { showError, showSuccess } from 'utils';
import styles from './index.module.scss';
import _ from 'lodash';

const AddUserHomeBoxPreferenceModal = props => {
  const [preference, setPreference] = useState<Record<string, any>>({});
  const [loading, setLoading] = useState<boolean>(false);
  const {
    closeModal,
    isEdit,
    onSuccess,
    preferenceToEdit,
    userId,
  } = props;
  
  useEffect(() => {
    if (isEdit) {
      setPreference({
        objectId: preferenceToEdit.objectId,  
        inventoryItem: {
          objectId: preferenceToEdit.inventoryItem?.objectId,
          name: preferenceToEdit.inventoryItem?.name,
        },
        probability: preferenceToEdit.probability,
        
      });
    }
  }, []);

  const addPreference = async () => {
    setLoading(true);
    try {
      await createUserInventoryItemPreference({
        inventoryItemId: preference.inventoryItem.objectId,
        probability: preference.probability,
        userId,
      });
      await onSuccess();
      showSuccess('Preference added successfully');
      closeModal();
    } catch (e) {
      showError(e);
      setLoading(false);
    }
  };

  const editPreference = async () => {
    setLoading(true);
    try {
      await updateUserInventoryItemPreference({
        preferenceId: preference.objectId,
        probability: preference.probability,
      });
      await onSuccess();
      showSuccess('Preference updated successfully');
      closeModal();
    } catch (e) {
      showError(e);
      setLoading(false);
    }
  };

  const handleSuggestionClick = (item: Record<string, any>) => {
    setPreference({
      ...preference,
      inventoryItem: {
        objectId: item.id,
        name: item.displayName,
      },
    });
  };

  const handleNameChange = (name: string) => {
    let inventoryItem = _.cloneDeep(preference.inventoryItem);
    if (!name) {
      inventoryItem = {
        objectId: '',
        name: '',
      };
    } else {
      inventoryItem = {
        ...inventoryItem,
        name,
      };
    }
    setPreference({
      ...preference,
      inventoryItem,
    });
  };

  return (
    <div className={styles['main-container']}>
      <div className={styles['modal-container']}>
        <div className={styles['modal-header']}>
          <div>
            <div className={styles['label']}>User</div>
            <div className={styles['modal-title']}>{`${isEdit ? 'Edit' : 'Add'} User Home Box Preference`}</div>
          </div>
          <i className={'fa fa-times'} onClick={closeModal} />
        </div>
        <div className={styles['modal-body']}>
          <div>
            <div className={styles['label']}>Item</div>
            <div className={styles['autosuggest-input']}>
              {isEdit ? (
                <input
                  className={'form-control'}
                  disabled={true}
                  value={preference.inventoryItem?.name || ''}
                />
              ) : (
                <SearchBar
                  disabled={loading}
                  value={preference.inventoryItem?.name || ''}
                  setValue={handleNameChange}
                  searchAPI={searchItems}
                  searchAPIParamKey={'term'}
                  onSuggestionClicked={handleSuggestionClick}
                />
              )}
            </div>
          </div>
          <div className={'my-3'}>
            <div className={styles['label']}>Probability</div>
            <input
              className={'form-control'}
              type={'number'}
              disabled={loading}
              value={preference.probability}
              onChange={e => setPreference({ ...preference, probability: parseInt(e.target.value) })}
            />
          </div>
        </div>
        <div className={styles['modal-footer']}>
          <button
            className={styles['cancel-button']}
            onClick={closeModal}
            disabled={loading}
            type={'button'}
          >
            Cancel
          </button>
          <button
            onClick={isEdit ? editPreference : addPreference}
            className={styles['submit-button']}
            disabled={loading}
          >
            Submit
          </button>
        </div>
      </div>
    </div>
  );
};

export default AddUserHomeBoxPreferenceModal;